import { CSSProperties, forwardRef } from 'react'

export interface LanguageFlagProps {
  code?: string
  /** Sets font-size inline, which beats any stylesheet: leave it out to size the flag in css */
  height?: number | string
  className?: string
  style?: CSSProperties
  id?: string
  'data-testid'?: string
}

export const LanguageFlag = forwardRef<HTMLSpanElement, LanguageFlagProps>(function LanguageFlag(
  { code, height, className, style, ...rest },
  ref
) {
  if (!code) {
    return (
      <span {...rest} ref={ref}>
        Unknown
      </span>
    )
  }

  const fontSize = typeof height === 'string' && /^\d+$/.test(height) ? Number(height) : height

  return (
    <span
      {...rest}
      ref={ref}
      className={`fi fi-${code.toLowerCase()}${className ? ` ${className}` : ''}`}
      style={{ flexShrink: 0, ...(height === undefined ? {} : { fontSize }), ...style }}
    />
  )
})
